import window from 'window-or-global';
import { isDarkFeatureEnabled } from '../../utils/dark-features-query-selector';
import { bind } from '@confluence-classic/confluence-event_DO_NOT_USE';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

function linkedInPasteHandler(uri, node, done) {
	// After doing some rough testing, most pages on LinkedIn tends to respond within a second,
	// however, some requests took up to 3526ms. Setting it with a little bit of a redundancy.
	const TIMEOUT = 5000;
	// Food for thought: What if I paste in a shortened link? e.g. a bit.ly link or something
	// Convert? No?
	if (uri.host.search('.linkedin.') === -1) {
		done();
		return;
	}

	const requestURL = `https://card-meta.atlassian.io/meta?url=${uri.source}`;

	$.ajax(requestURL, {
		timeout: TIMEOUT,
		success(data) {
			// when pasting in a private link, LinkedIn will redirect
			// to a sign in page. It doesn't make sense to convert the link
			// title in that case, so just don't convert
			if (data.title.search('Sign In') !== -1) {
				return;
			}

			// Removes "| LinkedIn" from profiles and articles
			const indexOfPipe = data.title.indexOf('|');
			const linkText = indexOfPipe === -1 ? data.title : data.title.substring(0, indexOfPipe);

			node.text(linkText);
			node.attr('href', uri.source);
		},
		error(xhr, errorStatus) {
			if (process.env.NODE_ENV !== 'production') {
				console.log(`Link conversion failed, Error: ${errorStatus}`);
			}
		},
		complete() {
			done();
		},
	});
}

export default function () {
	if (isDarkFeatureEnabled('autoconvert-link-to-page-title')) {
		bind('init.rte', () => {
			window.tinymce.plugins.Autoconvert.autoConvert.addHandler(linkedInPasteHandler);
		});
	}
}
